export const firebaseWebConfig = {
  apiKey: 'AIzaSyCXnha3P2mKKg0qpDQ0UfSlA3-nBEMjUEk',
  authDomain: 'mets-dist-bab47.firebaseapp.com',
  databaseURL: 'https://mets-dist-bab47.firebaseio.com',
  projectId: 'mets-dist-bab47',
  storageBucket: 'mets-dist-bab47.appspot.com',
  messagingSenderId: '518794106636',
  appId: '1:518794106636:web:202fec4c2928d8bd45db29',
  measurementId: 'G-KRSZD26CXQ'
};
